import React, { useState, useEffect } from "react";
import styles from "./ScrollToTopButton.module.css";
import { ScrollToTopButtonIcon } from "../../customIcons/ScrollToTopButton";

export const ScrollToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  const handleClick = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    const handleScroll = () => setIsVisible(window.scrollY > 100);

    handleScroll();
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <button
      type="button"
      aria-label="Scroll to top"
      className={`${styles.scrollToTop} ${isVisible ? styles.visible : ""}`}
      onClick={handleClick}
    >
      <ScrollToTopButtonIcon />
    </button>
  );
};
